import { FC } from 'react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/Form';
import RadioGroup, { RadioItem } from '@/components/ui/RadioGroup';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const DRYING_METHOD = {
  EQUIPMENT_RENTAL: 'equipment_rental',
  DRYING_COMPANY: 'drying_company',
} as const;

export const DRYING_METHOD_NAME = 'drying_method';

interface Props {
  name?: string;
}

export const RadioGroupDryingMethod: FC<Props> = ({
  name = DRYING_METHOD_NAME,
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
      }}
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            {i18n.t('Jaką metodą zostało wykonane osuszanie?')}
          </FormLabel>
          <FormControl>
            <RadioGroup {...field} layout="horizontal">
              <RadioItem
                data-testid={`${name}-radio-group-${DRYING_METHOD.EQUIPMENT_RENTAL}`}
                value={DRYING_METHOD.EQUIPMENT_RENTAL}
                label={i18n.t('Wypożyczenie sprzętu')}
              />
              <RadioItem
                data-testid={`${name}-radio-group-${DRYING_METHOD.DRYING_COMPANY}`}
                value={DRYING_METHOD.DRYING_COMPANY}
                label={i18n.t('Firma osuszająca')}
              />
            </RadioGroup>
          </FormControl>
        </FormItem>
      )}
    />
  );
};

export default RadioGroupDryingMethod;
